import { Analytics } from '@ycos/analytics'
import qs from 'qs'

export const trackOnProductClick = (item, product, index, brand) => () => {
  if (!item.href) return {}
  const { href } = item
  const hrefContainsAnalyticsString = href && href.indexOf('cm_sp=') !== -1
  const analytics = new Analytics({ brand: brand.brandId })

  if (hrefContainsAnalyticsString) {
    const campaignInfo = getCampaignEntry(item.href)
    const { nameEN, partNumber, badges, masterCategory } = product
    const stockBadges = filterStockBadges(badges)
    const productStock = stockBadges.length ? stockBadges[0]?.label : ''

    analytics.trackEvent({
      event: `view product - ${nameEN}`,
      eventEffect: 'go to product page',
      category: {
        primaryCategory: 'ecommerce',
        subCategory: 'rewards page'
      },
      attributes: {
        productFindingMethod: 'rewards page',
        position: `productcarousel${index + 1}`
      },
      item: [
        {
          productInfo: {
            productID: partNumber,
            productStock,
            primaryCategory: masterCategory?.labelEN,
            subcategory1: masterCategory?.child?.labelEN,
            productListName: item?.teaserTitle
          },
          attributes: {
            productFindingMethod: 'rewards page'
          }
        }
      ]
    })

    analytics.trackEvent({
      event: 'site merchandising - click',
      effect: 'campaign click',
      category: {
        primaryCategory: 'site merchandising',
        subCategory: 'campaign',
      },
      attributes: {
        siteMerchandising: {
          placement: 'campaign',
          position: `productcarousel${index + 1}`,
          campaignName: campaignInfo?.campaignName,
          campaignStartDate: campaignInfo?.campaignStartDate,
          modulePosition: `module${item?.analyticsMetadata?.moduleNumber}`,
        }
      }
    })
  }
}


export const getCampaignEntry = (link) => {
  const queryString = link.substring(link.indexOf('?') + 1)
  const queryParams = qs.parse(queryString)
  const cmspQueryParam = queryParams.cm_sp || ''

  if (!cmspQueryParam) return
  const params = cmspQueryParam.split('-_-') || []
  const noParam = params.some((p) => !p)
  if (noParam) return
  const [placement, position, campaignName, campaignStartDate] = params
  return {
    placement,
    position,
    campaignName,
    campaignStartDate
  }
}

const filterStockBadges = (badges = []) => {
  return badges.reduce((acc, badge) => {
    if (badge.type === 'STOCK') {
      acc.push(badge)
    }
    return acc
  }, [])
}
